module.exports = __webpack_public_path__ + "assets/4084638ec5afc624e5e010d198f34e50.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/mystery/PostBigAdd.mp3
 ** module id = 350
 ** module chunks = 0
 **/